import { Component, Inject, DOCUMENT } from '@angular/core';

import {
  faCircleXmark,
  faDownload,
  faFile,
  IconName,
} from '@fortawesome/free-solid-svg-icons';
import { LocaleService } from '@fullyops/shared/services/locale/locale.service';
import { SignedImageResponse } from '@fullyops/legacy/data/api/types/Image';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@fullyops/shared/material.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { I18NextModule } from 'angular-i18next';
export interface DialogData {
  imageUrl: string;
  title: string;
  file?: SignedImageResponse;
}

@Component({
  selector: 'fo-image-dialog',
  templateUrl: './image-dialog.component.html',
  styleUrls: ['./image-dialog.component.scss'],
  imports: [MaterialModule, FontAwesomeModule, I18NextModule],
})
export class ImageDialogComponent {
  constructor(
    private localeService: LocaleService,
    public dialogRef: MatDialogRef<ImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.lang = localeService.getCurrentLanguage();
  }
  fileIcon = faFile;
  faCircleXmark = faCircleXmark;
  faDownload = faDownload;

  lang: string;

  onCancel(): boolean {
    this.dialogRef.close();
    return false;
  }
  onLeave(): boolean {
    this.dialogRef.close();
    return true;
  }

  onDownload() {
    const link = this.document.createElement('a');
    link.target = '_blank';
    link.href = this.data.file.file.signedUrl;
    link.click();
    link.remove();
  }

  getFileTypeName(file: SignedImageResponse): IconName {
    const fileName = file.file.fileName.toLowerCase();

    const isImage = imagePattern.test(fileName);
    if (isImage) return 'image';
    const isVideo = videoPattern.test(fileName);
    if (isVideo) return 'video';
    if (fileName.endsWith('pdf')) return 'file-pdf';
    if (fileName.endsWith('docx')) return 'file-word';
    if (fileName.endsWith('csv')) return 'file-csv';
    return 'file';
  }

  formatFileName(fileName: string) {
    return fileName.split('.')[0];
  }
}

const imagePattern = /(?:jpe?g|png|gif|bmp|tiff?|svg|webp|raw|cr2|nef)$/;
const videoPattern = /(?:avi|mp4|mpe?g|ogv|webm|mov)$/;
